import { Swiper as SwiperType } from "swiper/types";

export type MediaGalleryReducerState = {
  thumbsSwiper?: SwiperType;
  currentSlide: number;
  mediaType: "photos" | "videos";
  isVideoPlaying: number | boolean;
};

type MediaGalleryReducerAction =
  | {
      type: "thumbsSwiper";
      thumbsSwiperPayload: MediaGalleryReducerState["thumbsSwiper"];
    }
  | {
      type: "currentSlide";
      currentSlidePayload: MediaGalleryReducerState["currentSlide"];
    }
  | {
      type: "mediaType";
      mediaTypePayload: MediaGalleryReducerState["mediaType"];
    }
  | {
      type: "isVideoPlaying";
      isVideoPlayingPayload: MediaGalleryReducerState["isVideoPlaying"];
    };

export const reducerMediaGallery = (
  state: MediaGalleryReducerState,
  action: MediaGalleryReducerAction
): MediaGalleryReducerState => {
  switch (action.type) {
    case "thumbsSwiper":
      return { ...state, thumbsSwiper: action.thumbsSwiperPayload };
    case "currentSlide":
      return { ...state, currentSlide: action.currentSlidePayload };
    case "mediaType":
      return { ...state, mediaType: action.mediaTypePayload };
    case "isVideoPlaying":
      return { ...state, isVideoPlaying: action.isVideoPlayingPayload };
  }
};
